<template>
	<div class="end">
		
		<div class="end-content">

			<div class="end-scores">
				<div class="end-score">
					<div class="end-score-label">{{ texts[lang].your_score }}</div>
					<div class="end-score-value">{{ game.score }}</div>
				</div>
				<div class="end-score">
					<div class="end-score-label">{{ texts[lang].best_score }}</div>
					<div class="end-score-value">{{ app.user.best_score }}</div>
				</div>
			</div>

			<div class="end-stats">
				<div class="end-stat">
					<div class="end-stat-label">{{ texts[lang].chains }}</div>
					<div class="end-stat-value">{{ nb_chains }}</div>
				</div>
				<div class="end-stat">
					<div class="end-stat-label">{{ texts[lang].destroyed_cards }}</div>
					<div class="end-stat-value">{{ tiles_destroyed }}</div>
				</div>
				<div class="end-stat">
					<div class="end-stat-label">{{ texts[lang].highest_chain }}</div>
					<div class="end-stat-value">{{ biggest_chain }}</div>
				</div>
				<div class="end-stat">
					<div class="end-stat-label">{{ texts[lang].longest_chain }}</div>
					<div class="end-stat-value">{{ longest_chain }}</div>
				</div>
			</div>

		</div>

		<div class="end-buttons">
			<v-touch @tap="start_game()" class="button blue">{{ texts[lang].retry }}</v-touch>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'End',
	data () {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'app', 'game', 'board', 'texts', 'lang' ]), {
		nb_chains: function() {
			return this.game.chains.length
		},
		tiles_destroyed: function() {
			var n = 0
			for (var i in this.game.chains) {
				n += this.game.chains[i].length
			}
			return n
		},
		biggest_chain: function() {
			var chain = _.maxBy(this.game.chains, function(chain) { return chain.length * chain[0].card.value })
			if (chain) return chain.length * chain[0].card.value
			return 0
		},
		longest_chain: function() {
			var chain = _.maxBy(this.game.chains, function(chain) { return chain.length })
			if (chain) return chain.length
			return 0
		},
	}),
	methods: {
		start_game: function() {
			sounds.play('tap')
			this.$store.dispatch('start_game')
		}
	}
}
</script>

<style lang="stylus">
@import '../../assets/css/app'


.end
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	.end-content
		position absolute
		left 8px
		top 8px
		right 8px
		height calc(100% - (56px + 32px + 8px))
		overflow auto
		.end-scores
			display flex
			align-items center
			justify-content center
			text-align center
			.end-score
				padding 24px 0
				width 50%
				.end-score-label
					display block
					color #999
					font-size 14px
				.end-score-value
					display block
					font-size 40px
					line-height @font-size
		.end-stats
			margin 8px 0 0 0
			padding 0 12px
			.end-stat
				display flex
				align-items center
				justify-content space-between
				padding 4px 16px
				background alpha(#000, 5%)
				margin 0 0 4px 0
				border-radius 4px
				.end-stat-label
					display inline-block
				.end-stat-value
					display inline-block
					font-size 24px
	.end-buttons
		position absolute
		left 16px
		right 16px
		bottom 16px
		text-align center
		.button
			display inline-block
			height 56px
			padding 0 28px
			background blue
			border-radius 8px
			box-shadow inset 0 -4px 0 0 alpha(#000, 15%)
			line-height (@height - 2px)
			color #fff
			font-size 20px
			&:active
				transform translate3D(0, 2px, 0) scale(0.95)
			

</style>



// WEBPACK FOOTER //
// src/components/game/End.vue